import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowRight, Sparkles } from 'lucide-react';
import { Button } from './ui/button';

/**
 * BuyerOnboardingCard — Phase 38
 * ------------------------------------------------------------------
 * Shown only inside the Wallet page when the user has *started* the
 * Stripe Connect onboarding flow but has not been verified yet
 * (`stripe_connect_id` set but `is_payout_ready` false). Keeps the
 * Wallet UI in "buyer mode" — no earnings/payout surface — but
 * reminds the user to finish the creator setup on the Profile page,
 * where the full `PayoutOnboardingCard` lives.
 */
const BuyerOnboardingCard = () => {
  const navigate = useNavigate();
  const { t } = useTranslation('wallet');

  return (
    <div
      className="mb-6 rounded-2xl border border-amber-500/40 bg-amber-500/5 p-5"
      data-testid="wallet-onboarding-card"
    >
      <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
        <div className="flex items-start gap-3">
          <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-amber-500/15 gold-text">
            <Sparkles className="h-5 w-5" />
          </div>
          <div>
            <p
              className="text-base font-semibold gold-text"
              data-testid="wallet-onboarding-title"
            >
              {t('creator_onboarding.title')}
            </p>
            <p
              className="mt-0.5 text-sm text-muted-foreground"
              data-testid="wallet-onboarding-desc"
            >
              {t('creator_onboarding.description')}
            </p>
          </div>
        </div>
        <Button
          onClick={() => navigate('/profile')}
          className="gold-gradient text-sm font-semibold text-black md:shrink-0"
          data-testid="wallet-onboarding-cta"
        >
          {t('creator_onboarding.cta')}
          <ArrowRight className="ml-2 h-4 w-4" />
        </Button>
      </div>
    </div>
  );
};

export default BuyerOnboardingCard;
